import {ProductOffering} from '@mintdata-wsp/common/controllers/network/generated/responses/ProductOffering';
import {observable} from 'mobx';
import {Product} from '@mintdata-wsp/common/controllers/network/generated/responses/Product';

export enum ProductType
{
    Cloud_Access = 'cloud_access',
    Addon = 'addon'
}

export class StorefrontState
{
    @observable
    productOffering:ProductOffering = null;

    @observable
    cloudAccessProducts:Product[] = null;

    @observable
    addonProducts:Product[] = null;
}
